(function ($) {
    "use strict";

    $(document).on('click', '.comparison-remove-product', function (e) {
        e.preventDefault();

        var $this = $(this);
        var model = $this.data('product-model');
        var productsCount = $('.OEProductsComparison-table-image-wrap').length;

        // ---------------------------
        // Detect type from wrapper
        // ---------------------------
        var productType = $('.OEProductsComparison').data('type') || 'default';

        // ---------------------------
        // Remove from localStorage (per type)
        // ---------------------------
        var key = 'comparisonProducts_' + productType;
        var storedProducts = JSON.parse(localStorage.getItem(key) || '[]');
        storedProducts = storedProducts.filter(function (m) { return m !== model; });
        localStorage.setItem(key, JSON.stringify(storedProducts));

        // ---------------------------
        // Remove from URL GET parameter
        // ---------------------------
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);
        var productsParam = params.get('products');

        if (productsParam) {
            var productsArray = productsParam.split(',');
            productsArray = productsArray.filter(function (p) { return p !== model; });

            if (productsArray.length > 0) {
                params.set('products', productsArray.join(','));
            } else {
                params.delete('products');
            }

            url.search = params.toString();
            window.history.replaceState({}, '', url.toString());
        }

        // ---------------------------
        // Remove the column from table
        // ---------------------------
        var $cell = $this.closest('.OEProductsComparison-table-value'); // find cell containing button
        var $row = $cell.closest('.OEProductsComparison-table-row'); // parent row
        var columnIndex = $row.children('.OEProductsComparison-table-value').index($cell); // index among siblings

        // Remove this column from all rows
        $row.closest('.OEProductsComparison-table').find('.OEProductsComparison-table-row').each(function () {
            $(this).children('.OEProductsComparison-table-value').eq(columnIndex).remove();
        });

        // ---------------------------
        // Add empty slot if needed
        // ---------------------------
        if (productsCount == 3) {
            $('.OEProductsComparison-table-heading').append(`
                <div class="OEProductsComparison-table-value OEProductsComparison-table-image-wrap">
                    <div class="OEProductsComparison-table-value OEProductsComparison-table-image-wrap-inner empty">
                        <div class="OEProductsComparison-table-image"></div>
                        <h6>Want to add another product?</h6>
                        <a href="/products/${productType}">Browse All</a>
                    </div>
                </div>
            `);
        }
    });

})(jQuery);